import { render } from "./ButtonCancel.vue?vue&type=template&id=d58c7682"
import script from "./ButtonCancel.vue?vue&type=script&lang=js"
export * from "./ButtonCancel.vue?vue&type=script&lang=js"
script.render = render

export default script